<template>
  <label :for="id" class="block text-sm font-medium text-gray-700">{{
    label
  }}</label>
  <div class="relative mt-1 rounded-md shadow-xs">
    <div
      class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
    >
      <slot name="inputPrefix"></slot>
    </div>
    <textarea
      :id="id"
      :name="id"
      :rows="rows"
      :placeholder="placeholder || ''"
      class="mt-1 block w-full rounded-md shadow-xs focus:outline-hidden sm:text-sm"
      :class="[
        v$[id].$error
          ? 'border-red-300 pr-10 text-red-900 focus:border-red-500 focus:ring-red-500'
          : 'border-gray-300 focus:border-indigo-500 focus:ring-indigo-500',
        inputClass,
      ]"
      :value="value"
      :aria-invalid="v$[id].$error"
      :aria-describedby="v$[id].$error ? `${id}-error` : ''"
      @input="(e) => onInput(e.target.value)"
    ></textarea>
    <div
      v-if="v$[id].$error"
      class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
    >
      <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
    </div>
  </div>
  <p
    v-for="error in v$[id].$errors"
    v-if="v$[id].$error"
    :id="`${id}-error`"
    class="mt-2 text-sm text-red-600"
  >
    {{ error.$message }}
  </p>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { ExclamationCircleIcon } from '@heroicons/vue/20/solid'

export default {
  name: 'FormTextarea',
  components: { ExclamationCircleIcon },
  props: {
    value: String,
    id: String,
    label: String,
    onInput: Function,
    rules: Object,
    placeholder: String,
    inputClass: String,
    rows: {
      type: Number,
      default: 3,
    },
  },
  setup(props) {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: 'global',
    })

    const rules = computed(() => ({
      [props.id]: props.rules,
    }))

    const v$ = useVuelidate(rules, {
      [props.id]: computed(() => props.value),
    })

    return { t, v$ }
  },
}
</script>
